




















































































import Vue, { PropOptions } from 'vue';
import draggable from 'vuedraggable';
import PathContentItem from '@/components/bots/PathContentItem.vue';
import ModalCreateBotPath from '@/components/bots/ModalCreateBotPath.vue';
import { OmniChatSchema } from '@omnichat/omnichat-model';

export default Vue.extend({
  components: { draggable, PathContentItem, ModalCreateBotPath },
  props: {
    index: {
      type: Number,
    },
    path: {
      type: Object,
    } as PropOptions<OmniChatSchema.BotState>,
    statePaths: {
      type: Array,
    } as PropOptions<OmniChatSchema.BotState[]>,
  },
  data() {
    return {
      showCreate: false,
      botPath: {
        type: Object,
      },
      componentKey: 0,
    };
  },
  methods: {
    onShowDialog() {
      (this as any).botPath = undefined;
      (this as any).showCreate = true;
    },
    onCloseDialog() {
      (this as any).showCreate = false;
    },
    getToPathIntex(path: OmniChatSchema.BotState) {
      if ([
          OmniChatSchema.BotHandlerType.botStateChangeHandler,
          OmniChatSchema.BotHandlerType.channelStateChangeHandler,
          OmniChatSchema.BotHandlerType.sendToChannel,
        ].indexOf(path.handlerType) !== -1) {
        const index = this.statePaths.findIndex((p: any) => path.title === p.title);
        return String.fromCharCode(65 + index);
      }

      return '0';
    },
    onDeletePath() {
      this.$emit('deletePath', this.path);
    },
    onEditPathItem(pathItem: OmniChatSchema.BotState) {
      (this as any).componentKey++;
      (this as any).botPath = pathItem;
      (this as any).showCreate = true;
    },
    onDeletePathItem(pathItem: OmniChatSchema.BotState) {
      (this as any).componentKey++;
      if (this.path.toState && this.path.toState.to) {
        this.path.toState.to = this.path.toState.to.filter((p: OmniChatSchema.BotState) => p !== pathItem);

        this.$emit('deletePathItem', pathItem);
      }
    },
    onSaveBotPath(botPath: OmniChatSchema.BotState) {
      botPath.index = this.path.toState && this.path.toState.to ? this.path.toState.to.length + 1 : 1;
      this.path.toState && this.path.toState.to.push(botPath);
      (this as any).onCloseDialog();
      (this as any).componentKey++;
      this.$emit('saveBot');
    },
    onUpdateBotPath() {
      (this as any).onCloseDialog();
      (this as any).componentKey++;
      this.$emit('saveBot');
    },
  },
  computed: {
    indexLetter: {
      get() {
        return String.fromCharCode(65 + this.index);
      },
    },
  },
});
